import "./PageLoader.css";

export default function PageLoader({ label = "Loading" }) {
  return (
    <div className="page-loader" role="status" aria-live="polite" aria-label={label}>
      <span className="page-loader__spinner" aria-hidden="true" />
      <span className="page-loader__sr-only">{label}</span>
    </div>
  );
}
